var Opal = require('../opal').default; /* Generated by Opal 0.11.99.dev */
(function(Opal) {
  function $rb_minus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs - rhs : lhs['$-'](rhs);
  }
  function $rb_times(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs * rhs : lhs['$*'](rhs);
  }
  function $rb_plus(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs + rhs : lhs['$+'](rhs);
  }
  function $rb_ge(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs >= rhs : lhs['$>='](rhs);
  }
  function $rb_le(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs <= rhs : lhs['$<='](rhs);
  }
  function $rb_gt(lhs, rhs) {
    return (typeof(lhs) === 'number' && typeof(rhs) === 'number') ? lhs > rhs : lhs['$>'](rhs);
  }
  var self = Opal.top, $nesting = [], nil = Opal.nil, $$$ = Opal.const_get_qualified, $$ = Opal.const_get_relative, $breaker = Opal.breaker, $slice = Opal.slice, $klass = Opal.klass, $send = Opal.send, $gvars = Opal.gvars, $truthy = Opal.truthy;

  Opal.add_stubs(['$debug', '$sub', '$-', '$*', '$to_i', '$+', '$==', '$!=', '$>=', '$<=', '$>']);
  return (function($base, $super, $parent_nesting) {
    var self = $klass($base, $super, 'NightmareHunterDeep');

    var $nesting = [self].concat($parent_nesting), $NightmareHunterDeep_initialize$1, $NightmareHunterDeep_gameName$2, $NightmareHunterDeep_gameType$3, $NightmareHunterDeep_getHelpMessage$4, $NightmareHunterDeep_changeText$5, $NightmareHunterDeep_check_nD6$8, $NightmareHunterDeep_getDiceRolledAdditionalText$9, $NightmareHunterDeep_getDiceRevision$10;

    
    
    Opal.def(self, '$initialize', $NightmareHunterDeep_initialize$1 = function $$initialize() {
      var $iter = $NightmareHunterDeep_initialize$1.$$p, $yield = $iter || nil, self = this, $zuper = nil, $zuper_i = nil, $zuper_ii = nil;

      if ($iter) $NightmareHunterDeep_initialize$1.$$p = null;
      // Prepare super implicit arguments
      for($zuper_i = 0, $zuper_ii = arguments.length, $zuper = new Array($zuper_ii); $zuper_i < $zuper_ii; $zuper_i++) {
        $zuper[$zuper_i] = arguments[$zuper_i];
      }
      
      $send(self, Opal.find_super_dispatcher(self, 'initialize', $NightmareHunterDeep_initialize$1, false), $zuper, $iter);
      self.sendMode = 2;
      return (self.sortType = 1);
    }, $NightmareHunterDeep_initialize$1.$$arity = 0);
    
    Opal.def(self, '$gameName', $NightmareHunterDeep_gameName$2 = function $$gameName() {
      var self = this;

      return "ナイトメアハンター=ディープ"
    }, $NightmareHunterDeep_gameName$2.$$arity = 0);
    
    Opal.def(self, '$gameType', $NightmareHunterDeep_gameType$3 = function $$gameType() {
      var self = this;

      return "NightmareHunterDeep"
    }, $NightmareHunterDeep_gameType$3.$$arity = 0);
    
    Opal.def(self, '$getHelpMessage', $NightmareHunterDeep_getHelpMessage$4 = function $$getHelpMessage() {
      var self = this;

      return "" + "加算ロール時に６の個数をカウントして、その４倍を自動的に加算します。\n" + "(出目はそのまま表示で合計値が6-10の読み替えになります)\n"
    }, $NightmareHunterDeep_getHelpMessage$4.$$arity = 0);
    
    Opal.def(self, '$changeText', $NightmareHunterDeep_changeText$5 = function $$changeText(string) {
      var $$6, $$7, self = this;

      
      self.$debug("parren_killer_add before string", string);
      string = $send(string, 'sub', [/^(.+?)Lv(\d+)(.*)/i], ($$6 = function(){var self = $$6.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + ($rb_minus($rb_times(__last__match__2.$to_i(), 5), 1)) + (__last__match__3);}, $$6.$$s = self, $$6.$$arity = 0, $$6));
      string = $send(string, 'sub', [/^(.+?)NL(\d+)(.*)/i], ($$7 = function(){var self = $$7.$$s || this, $a, __last__match__1 = nil, __last__match__2 = nil, __last__match__3 = nil, __last__match__4 = nil, __last__match__5 = nil, __last__match__6 = nil, __last__match__7 = nil, __last__match__8 = nil, __last__match__9 = nil, __last__match__10 = nil, __last__match__11 = nil, __last__match__12 = nil, __last__match__13 = nil, __last__match__14 = nil, __last__match__15 = nil, __last__match__16 = nil, __last__match__17 = nil, __last__match__18 = nil, __last__match__19 = nil, __last__match__20 = nil;

      
        __last__match__1 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](1));
        __last__match__2 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](2));
        __last__match__3 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](3));
        __last__match__4 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](4));
        __last__match__5 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](5));
        __last__match__6 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](6));
        __last__match__7 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](7));
        __last__match__8 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](8));
        __last__match__9 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](9));
        __last__match__10 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](10));
        __last__match__11 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](11));
        __last__match__12 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](12));
        __last__match__13 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](13));
        __last__match__14 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](14));
        __last__match__15 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](15));
        __last__match__16 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](16));
        __last__match__17 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](17));
        __last__match__18 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](18));
        __last__match__19 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](19));
        __last__match__20 = (($a = $gvars['~']) === nil ? nil : $a['$[]'](20));
        return "" + (__last__match__1) + ($rb_plus($rb_times(__last__match__2.$to_i(), 5), 5)) + (__last__match__3);}, $$7.$$s = self, $$7.$$arity = 0, $$7));
      self.$debug("parren_killer_add after string", string);
      return string;
    }, $NightmareHunterDeep_changeText$5.$$arity = 1);
    
    Opal.def(self, '$check_nD6', $NightmareHunterDeep_check_nD6$8 = function $$check_nD6(total_n, dice_n, signOfInequality, diff, dice_cnt, dice_max, n1, n_max) {
      var $a, self = this, sucLv = nil, sucNL = nil;
      if ($gvars.signOfInequality == null) $gvars.signOfInequality = nil;

      
      if ($truthy($gvars.signOfInequality['$=='](">="))) {
      } else {
        return ""
      };
      if ($truthy(diff['$!=']("?"))) {
        
        if ($truthy($rb_ge(total_n, diff))) {
          return " ＞ 成功"};
        return " ＞ 失敗";};
      sucLv = 1;
      sucNL = 0;
      while ($truthy($rb_ge(total_n, $rb_minus($rb_times(sucLv, 5), 1)))) {
        sucLv = $rb_plus(sucLv, 1)
      };
      while ($truthy($rb_ge(total_n, $rb_plus($rb_times(sucNL, 5), 5)))) {
        sucNL = $rb_plus(sucNL, 1)
      };
      sucLv = $rb_minus(sucLv, 1);
      sucNL = $rb_minus(sucNL, 1);
      if ($truthy($rb_le(sucLv, 0))) {
        return " ＞ 失敗"
      } else {
        return "" + " ＞ Lv" + (sucLv) + "/NL" + (sucNL) + "成功"
      };
    }, $NightmareHunterDeep_check_nD6$8.$$arity = 8);
    
    Opal.def(self, '$getDiceRolledAdditionalText', $NightmareHunterDeep_getDiceRolledAdditionalText$9 = function $$getDiceRolledAdditionalText(n1, n_max, dice_max) {
      var $a, self = this;

      
      self.$debug("getDiceRolledAdditionalText begin: n1, n_max, dice_max", n1, n_max, dice_max);
      if ($truthy(($truthy($a = n1['$!='](0)) ? dice_max['$=='](6) : $a))) {
        return " ＞ 宿命獲得"};
      return "";
    }, $NightmareHunterDeep_getDiceRolledAdditionalText$9.$$arity = 3);
    return (Opal.def(self, '$getDiceRevision', $NightmareHunterDeep_getDiceRevision$10 = function $$getDiceRevision(n_max, dice_max, total_n) {
      var $a, self = this, addText = nil, revision = nil;

      
      addText = "";
      revision = 0;
      if ($truthy(($truthy($a = $rb_gt(n_max, 0)) ? dice_max['$=='](6) : $a))) {
        
        revision = $rb_times(n_max, 4);
        addText = "" + "+" + (n_max) + "*4 ＞ " + ($rb_plus(total_n, revision));};
      return [addText, revision];
    }, $NightmareHunterDeep_getDiceRevision$10.$$arity = 3), nil) && 'getDiceRevision';
  })($nesting[0], $$($nesting, 'DiceBot'), $nesting)
})(Opal);
